

const BeAware = () => {
  return (
    <div>BeAware</div>
  )
}

export default BeAware